import { render, staticRenderFns } from "./EmailAndNotes.vue?vue&type=template&id=22f5bf80"
import script from "./EmailAndNotes.vue?vue&type=script&lang=ts"
export * from "./EmailAndNotes.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports